// This icon file is generated automatically.
var PUploadOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M4.25 2.96H5.4v5.29c0 .07.06.13.13.13h.94c.07 0 .12-.06.12-.13V2.96h1.16c.1 0 .16-.12.1-.2L6.1.55a.12.12 0 00-.2 0L4.15 2.76c-.06.08 0 .2.1.2zm7.47 4.82h-.94a.13.13 0 00-.12.13v2.4H1.34v-2.4a.13.13 0 00-.12-.13H.28a.13.13 0 00-.12.13V11c0 .28.22.5.5.5h10.68a.5.5 0 00.5-.5V7.9a.13.13 0 00-.12-.12z", "fill-rule": "nonzero" } }] }, "name": "p-upload", "theme": "outlined" };
export default PUploadOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PUploadOutlined.js
// module id = 3710
// module chunks = 0